export default "/images/4606a4fac314a6378481218eedae9d15.avif";